define([
    "../nlgHealthCheckerModule",
    "text!./nlgHealthCheckerErrorLevelCountReason.html",
], function (module, template) {
    "use strict";

    return module.directive("nlgHealthCheckerErrorLevelCountReason", [function () {
        return {
            template: template,
            scope: {
                reason: "<"
            }
        };
    }]);
});
